import constant from '@/libs/constant/constants'

export default{
    name: 'main-footer',
    data() {
        return {
            isInfoPortal: false
        }
    },
    created() {
        if(this.$route.path.includes('/ip/') || this.$route.path.includes('/dp/') || this.$route.path.includes('/short-url/') || this.$route.path.includes('/locations/')) this.isInfoPortal = true
        else this.isInfoPortal = false
    },
    watch: {
        '$route' (to) {
            if (to.path.includes('/ip/') || to.path.includes('/dp/') || to.path.includes('/short-url/') || to.path.includes('/locations/')) {
                this.isInfoPortal = true
            } else {
                this.isInfoPortal = false
            }
        }
    },
    methods:{
        /*
         * opens the email window when user clicks on
         * 'message' on footer bar.
         * */
        openEmailWindow(){
            window.location.href = `mailto:${constant.support.SUPPORT_EMAIL}`;
        },
        /*
         * opens the Leaning center link in new tab
         * */
        openLearningCenter(){
            window.open(`${constant.support.LEARNING_CENTER}`)
        }
    }
}
